export const API_EXTERNAL_ENDPOINT = 'bookmarks/delete'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/bookmarks/delete'
